<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h2>Daiktas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2" v-if="modalloading">
          <v-card-text class="mb-0 pb-0">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" v-if="!modalloading">
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12">
                <el-autocomplete
                  required
                  :readonly="readonly"
                  :items="daiktasRusys"
                  itemvalue="value"
                  itemtext="text"
                  label="Daikto rūšis"
                  tooltip="Sutartis. Daiktas. Daikto rūšis"
                  v-model="modalDaiktas.dai_rusis_kla_id"
                  :autofocus="!readonly"
                />
              </v-col>
              <v-col cols="12">
                <el-textarea
                  required
                  :readonly="readonly"
                  label="Daikto aprašymas"
                  tooltip="Sutartis. Daiktas. Daikto aprašymas"
                  :counter="2000"
                  v-model="modalDaiktas.dai_aprasymas"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button v-if="!readonly" primary @click.native="saveData()">
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import HipotekaMap from '../hipoteka/hipotekaMap'

export default {
  name: 'ModalDaiktas',
  props: {
    value: Boolean,
    readonly: Boolean,
    daiktas: Object,
    daiktasRusys: Array,
  },
  data() {
    return {
      loading: true,
      loadingRegistras: false,
      modalDaiktas: {},
      modalloading: true,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.modalloading = true
    if (this.daiktas.dai_id > 0) {
      this.modalDaiktas = this.daiktas
    } else {
      this.modalDaiktas = {}
    }
    this.modalloading = false
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('savedData', this.modalDaiktas)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.modalDaiktas = {}
    },
    submit() {
      if (!this.readonly) {
        this.saveData()
      }
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
